module.exports = __webpack_public_path__ + "static/img/taitou.e6a0bcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/member/taitou.png
// module id = CFwp
// module chunks = 2